/** @module Specification/BOM/ProductSize2Switchboard */
define([
	"dojo/_base/declare",
	"./ProductSwitchboard"
], function(declare,ProductSwitchboard) {
	
	return declare(ProductSwitchboard, {
		idViewProperty: "bomActiveSizes2",
		productSizeName: "bomSize2Name",
		productStoreName: "bomSize2Store"
	});
});
